// Öffentlicher API-Client für den Gratis-Tier (ohne Login, kein Bearer-Token).
// Spiegelt nur die anmeldungsfreien /api/public/* Endpoints. Bei 401-Logik o.ä.
// bewusst NICHT client.js verwenden (das würde auf /login umleiten).
const API_BASE = process.env.REACT_APP_API_URL || '';

async function publicFetch(path) {
  const res = await fetch(`${API_BASE}${path}`, { cache: 'no-store' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: `HTTP ${res.status}` }));
    throw new Error(err.detail || `HTTP ${res.status}`);
  }
  return res.json();
}

export function getFreeWorkouts() {
  return publicFetch('/api/public/workouts');
}

export function getFreeWorkout(id) {
  return publicFetch(`/api/public/workouts/${id}`);
}
